import { onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useKlaroConsent } from './useKlaroConsent'
import { useAnalyticsConfig } from './useAnalyticsConfig'

export function useMetaPixel() {
  const route = useRoute()
  const { hasMetaPixelConsent } = useKlaroConsent()
  const { shouldLoadGoogleAnalytics } = useAnalyticsConfig()

  // Sprawdź czy fbq jest dostępny
  const isFbqAvailable = () => {
    return typeof window !== 'undefined' && window.fbq
  }

  // Sprawdź czy użytkownik wyraził zgodę na Meta Pixel
  const hasConsent = () => {
    return hasMetaPixelConsent() && shouldLoadGoogleAnalytics.value
  }

  // Śledź widok strony
  const trackPageView = () => {
    if (!hasConsent() || !isFbqAvailable()) {
      return
    }

    window.fbq('track', 'PageView')
  }

  // Śledź zdarzenie
  const trackEvent = (eventName, parameters = {}) => {
    if (!hasConsent() || !isFbqAvailable()) return

    window.fbq('track', eventName, parameters)
  }

  // Śledź kliknięcie w ofertę
  const trackOfferClick = (offerId, offerTitle) => {
    trackEvent('ViewContent', {
      content_type: 'product',
      content_ids: [offerId],
      content_name: offerTitle,
      value: 0,
      currency: 'PLN'
    })
  }

  // Śledź wyszukiwanie
  const trackSearch = (query, resultsCount) => {
    trackEvent('Search', {
      search_string: query,
      content_category: 'vehicles',
      num_items: resultsCount
    })
  }

  // Śledź dodanie do ulubionych
  const trackFavorite = (offerId, offerTitle, isAdd) => {
    trackEvent(isAdd ? 'AddToWishlist' : 'RemoveFromWishlist', {
      content_type: 'product',
      content_ids: [offerId],
      content_name: offerTitle,
      value: 0,
      currency: 'PLN'
    })
  }

  // Śledź dodanie do porównania
  const trackComparison = (offerId, offerTitle, isAdd) => {
    trackEvent(isAdd ? 'AddToCart' : 'RemoveFromCart', {
      content_type: 'product',
      content_ids: [offerId],
      content_name: offerTitle,
      value: 0,
      currency: 'PLN'
    })
  }

  // Śledź logowanie
  const trackLogin = (method) => {
    trackEvent('CompleteRegistration', {
      registration_source: method,
      content_category: 'authentication'
    })
  }

  // Śledź rejestrację
  const trackRegistration = (method) => {
    trackEvent('CompleteRegistration', {
      registration_source: method,
      content_category: 'authentication'
    })
  }

  // Śledź dodanie oferty
  const trackAddOffer = () => {
    trackEvent('Lead', {
      content_category: 'content_creation',
      content_name: 'Add Offer'
    })
  }

  // Śledź edycję oferty
  const trackEditOffer = (offerId) => {
    trackEvent('Lead', {
      content_category: 'content_creation',
      content_name: 'Edit Offer',
      content_ids: [offerId]
    })
  }

  // Śledź kontakt
  const trackContact = (method) => {
    trackEvent('Contact', {
      content_category: 'contact',
      content_name: method
    })
  }

  // Automatyczne śledzenie zmian routingu
  const setupRouteTracking = () => {
    watch(
      () => route.path,
      (newPath, oldPath) => {
        if (newPath !== oldPath) {
          // Małe opóźnienie aby strona się załadowała
          setTimeout(() => {
            trackPageView()
          }, 100)
        }
      },
      { immediate: true }
    )
  }

  // Inicjalizacja śledzenia
  onMounted(() => {
    setupRouteTracking()
  })

  return {
    trackPageView,
    trackEvent,
    trackOfferClick,
    trackSearch,
    trackFavorite,
    trackComparison,
    trackLogin,
    trackRegistration,
    trackAddOffer,
    trackEditOffer,
    trackContact,
    isFbqAvailable
  }
}
